import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SlotCacheService {
  private slotsCache: { [key: string]: any[] } = {};

  private generateCacheKey(monthKey: string, operatories: string): string {
    return `${monthKey}_${operatories}`;
  }

  getCachedSlots(monthKey: string, operatories: string): any[] | null {
    const cacheKey = this.generateCacheKey(monthKey, operatories);
    return this.slotsCache[cacheKey] || null;
  }

  setCachedSlots(monthKey: string, operatories: string, slots: any[]): void {
    const cacheKey = this.generateCacheKey(monthKey, operatories);
    this.slotsCache[cacheKey] = slots;
  }


  clearCache(): void {
    this.slotsCache = {};
  }
}
